import { render } from "./EmailField.vue?vue&type=template&id=2bd7d1e9&scoped=true"
import script from "./EmailField.vue?vue&type=script&lang=js"
export * from "./EmailField.vue?vue&type=script&lang=js"

import "./EmailField.vue?vue&type=style&index=0&id=2bd7d1e9&scoped=true&lang=css"

import exportComponent from "/Users/chrisrooster/Documents/Sites/mycelium/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd7d1e9"]])

export default __exports__